import React, { useEffect, useMemo } from 'react';
import { isString, isUndefined } from 'lodash';
import { useGlobalStore } from '../../../lib/store';
import { useInputStore } from '../../../lib/input';

import General from './tabs/general';

import Tabs from '../../../components/common/tabs';
import Companies from './tabs/companies';

const InputContext = React.createContext();

const Profile = ({ _id, mode, prefix, title, titleIcon }) => {
  const { setDefaultTopnav } = useGlobalStore();
  const store = useInputStore({
    title,
    id: _id,
    prefix,
    mode,
    queryParams: '?populate=companies.company',
    customValidateFields: {
      input__company_id: 'current_company.company._id',
      input__company_effective_date: 'current_company.effective_date',
      input__company_end_date: 'current_company.end_date',
    },
    customFieldsModifier: (changes, rawData) => {
      if (
        !isUndefined(changes['input__company_id']) &&
        isString(changes['input__company_id'])
      ) {
        changes['input__company_effective_date'] =
          changes['input__company_effective_date'] ||
          rawData?.current_company?.effective_date;
        changes['input__company_end_date'] =
          changes['input__company_end_date'] ||
          rawData?.current_company?.end_date;
      } else if (
        changes['input__company_effective_date'] ||
        changes['input__company_end_date']
      ) {
        changes['input__company_object_id'] = rawData?.current_company?._id;
      }
      return changes;
    },
  });
  const { canSave, initStore, save } = store;

  const tabs = useMemo(
    () => [
      {
        label: '司機基本資料',
        component: <General context={InputContext} />,
        props: {},
      },
      // {
      // 	label: 'Company',
      // 	component: <Companies context={InputContext} />,
      // 	props: {},
      // },
    ],
    []
  );
  useEffect(() => {
    initStore({ _id, mode, prefix });
  }, []);
  useEffect(() => {
    setDefaultTopnav({
      url: `/${prefix}`,
      title,
      canSave,
      save,
      mode,
      titleIcon,
      // copy: mode === 'edit' && `/${prefix}/copy/${_id}`,
    });
  }, [prefix, canSave, save, title, titleIcon]);

  return (
    <InputContext.Provider value={store}>
      <Tabs tabs={tabs} prefix={prefix} />
    </InputContext.Provider>
  );
};

export default Profile;
